import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Nav,
    NavItem,
    NavLink,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    TabContent,
    TabPane,
    Table,
    UncontrolledDropdown,
} from "reactstrap";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingData from "../TESTPage/LoadingData";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import ModalDeleteBorrowTable from "./TableBorrowPage/ModalDeleteBorrowTable";
import ModalBorrowTable from "./TableBorrowPage/ModalBorrowTable";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import Menu2 from '../ResorceOnline/SetDataTool/Menu/Menu2';
import MyThaiDatePick from "../../components/Common/ThaiDatePicker";
import dayjs from "dayjs";
import { FetchAxiosGet, FetchAxiosPost, FetchAxiosPut } from "../../api/axios";
import ModalAcceptBorrowTable from "./TableBorrowPage/ModalAcceptBorrowTable";
import ModalUser from "../SetData/SetCommander/ModalUser";
import { useInsertConText } from "../Context/InsertContext";
import Menu3 from "./SetDataTool/Menu/Menu3";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import ExcelExportComponent from "../ResorceOnline/Report/ExcelExportComponent";
import { element } from "prop-types";

const BorrowedTable = ({
    modalState,
    setModalState,
    openBorrow,
    toggleModal,
    fromIndex,
    propFuc,
}) => {
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_CORS;
    const token = GetCookieToken("userToken");
    const user = GetCookieData("userData");
    const filterSubAdmin = user?.positionSubAdmin?.map(i => i.type_sub_admin);
    const user_id = user.user_id;
    const user_name = user.user_name;

    const [selectID, setSelectID] = useState();
    const [modal1, setModal1] = useState(false);

    const toggleViewModal = () => setModal1(!modal1);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setLoading(true);
        }, 1000);
    }, []);

    const convetToSplitDateTime = (dateTime) => {
        let OBJdateTime = {
            date: dateTime.split("T")[0],
            time: dateTime.split("T")[1].split(".")[0],
        };
        return OBJdateTime;
    };

    const [data, setData] = React.useState({
        users_name_borrow: user.user_name,
        users_id_borrow: user.user_id,
        date_borrow: new Date(),
        date_return: new Date(),
        equipment_id: "",
        status: 0,
    });

    const [borrowData, setBorrowData] = React.useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState();

    const getBorrowDataTable = async (page) => {
        let groupArray = []
        const pageParam = page || 1;
        const user_id = user.user_id;
        let params = new URLSearchParams({
            page: pageParam,
            size: 10,
            "order[0]": "created_date",
            "order[1]": "DESC"
        });
        if (filterSubAdmin.length === 0 || (Number(filterSubAdmin) !== 0 && Number(filterSubAdmin) !== 4)) {
            params.append("filter[users_id_borrow][0]", user_id)
        }
        const borrowData = await FetchAxiosGet("/api/borrow/equipment/datatable", token, params)
        setBorrowData(borrowData.result)

        setCheckboxState(borrowData.result?.reduce((acc, _, index) => ({ ...acc, [index]: { condition: false } }), {}))

        borrowData.result?.map(i => {
            groupArray.push(Number(i.equipment_id))
        })
        letEquipmentName(groupArray)
        setCurrentPage(borrowData.info.currentPage);
        setTotalPage(borrowData.info.totalPage);
    };

    const [keyDate, setKeyDate] = useState(0);
    const [searchData, setSearchData] = useState({
        mDataName: null,
        dateBorrow: null,
        dateReturn: null,
        equipmentId: null,
        status: null,
        userNameBorrow: null,
        typeName: null,
    });

    const filterHasData = () => {
        if (
            searchData.mDataName !== null ||
            searchData.dateBorrow !== null ||
            searchData.dateReturn !== null ||
            searchData.equipmentId !== null ||
            searchData.status !== null ||
            searchData.userNameBorrow !== null
            // ||
            // searchData.typeName !== null
        ) { return true; } else { return false; }
    }

    /**
     * ดึงข้อมูลรายการยืม-คืนอุปกรณ์ (datatable) ตามเงื่อนไขค้นหาและสิทธิ์ผู้ใช้
     * @param {number} page - หน้าปัจจุบัน (ถ้าไม่ส่งมาจะใช้ 1)
     */
    const getSearchData = async (page = 1) => {
        try {
            // 1) เตรียม URL และพารามิเตอร์พื้นฐาน
            const url = `${baseURL}/api/borrow/equipment/datatable`;

            const params = new URLSearchParams({
                page: String(page),
                size: "10",
                "order[0]": "created_date",
                "order[1]": "DESC",
                // default: จำกัดข้อมูลเฉพาะรายการที่ user นี้เป็นผู้ยืม
                "filter[users_id_borrow][0]": String(user_id),
            });

            // 2) กรณีเป็น SubAdmin บางประเภท: อนุญาตให้ดูรายการทั้งหมด (ไม่จำกัด users_id_borrow)
            const isSubAdminAll =
                Array.isArray(filterSubAdmin) &&
                filterSubAdmin.length > 0 &&
                (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4);

            if (isSubAdminAll) {
                params.delete("filter[users_id_borrow][0]");
            }

            // 3) สร้างรายการ filter จาก searchData (ใส่เฉพาะค่าที่มีจริง)
            const filters = [
                ["filter[mdata_name][0]", searchData.mDataName],
                ["filter[dmy_borrow][0]", searchData.dateBorrow],
                ["filter[dmy_return][0]", searchData.dateReturn],
                ["filter[status][0]", searchData.status],
                ["filter[item_format][0]", searchData.opdcId],
                [
                    "filter[users_name_borrow][0]",
                    searchData.userNameBorrow === "ทั้งหมด" ? null : searchData.userNameBorrow,
                ],
                ["filter[type_name][0]", searchData.typeName],
            ];

            // helper: เช็คค่าว่าง (กัน null/undefined/"" )
            const hasValue = (v) => v !== null && v !== undefined && v !== "";

            for (const [key, value] of filters) {
                if (hasValue(value)) params.append(key, String(value));
            }

            // 4) เรียก API
            const { data } = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
                params,
            });

            // 5) อัปเดต state สำหรับตาราง
            const rows = data?.result ?? [];
            setBorrowData(rows);

            // set ค่า checkbox เริ่มต้นของแต่ละแถว (condition: false)
            setCheckboxState(
                rows.reduce((acc, _row, index) => {
                    acc[index] = { condition: false };
                    return acc;
                }, {})
            );

            // 6) สะสม equipment_id เพื่อไปดึงชื่ออุปกรณ์ต่อ
            const equipmentIds = rows
                .map((r) => Number(r.equipment_id))
                .filter((n) => Number.isFinite(n));

            letEquipmentName(equipmentIds);

            // 7) อัปเดต pagination
            setCurrentPage(data?.info?.currentPage ?? 1);
            setTotalPage(data?.info?.totalPage ?? 1);
        } catch (err) {
            console.error(err);
        }
    };

    const [typeData, setTypeData] = useState([])

    const getTypeData = () => {
        const url = `${baseURL}/api/equipment/type`;
        axios
            .get(url,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                setTypeData(res.data.result);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        getTypeData()
        //typeData.unshift({ type_name: "ทั้งหมด", type_name_count: null })
    }, [])

    const allTypeOptions = [{ type_name: "ทั้งหมด", type_name_count: null }, ...typeData];

    const [deleteBorrow, setDeleteBorrow] = useState(false);
    const handleToggleModalDeleteBorrow = () => {
        setDeleteBorrow(!deleteBorrow);
    };
    const deleteRowBorrow = (id) => {
        setBorrowData((prev) => prev.filter((item) => item.id !== id));
        axios
            .delete(baseURL + `/api/borrow/equipment/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
            })
            .catch((err) => {
                console.error(err);
            });
        handleToggleModalDeleteBorrow();
    };

    const [dataEdit, setDataEdit] = useState({
        id: "",
        users_name_borrow: "",
        users_id_borrow: "",
        date_borrow: "",
        date_return: "",
        equipment_id: "",
        remark_borrow: "",
        remark_return: "",
        searchData: "",
        user_name_allot: "",
        user_name_repatriate: "",
        users_name_returner: "",
        status: 0,
    });

    const getBorrowById = (id) => {
        axios
            .get(
                baseURL +
                `/api/borrow/equipment/datatable?page=1&size=1&order[0]=created_date&order[1]=ASC&filter[id][0]=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then((res) => {
                setDataEdit({
                    id: res.data.result[0].id,
                    users_name_borrow: res.data.result[0].users_name_borrow,
                    users_id_borrow: res.data.result[0].users_id_borrow,
                    date_borrow: res.data.result[0].date_borrow,
                    date_return: res.data.result[0].date_return,
                    equipment_id: res.data.result[0].equipment_id,
                    remark_borrow: res.data.result[0].remark_borrow,
                    remark_return: res.data.result[0].remark_return,
                    user_name_allot: res.data.result[0].user_name_allot,
                    user_name_repatriate: res.data.result[0].user_name_repatriate,
                    users_name_returner: res.data.result[0].users_name_returner,
                    status: res.data.result[0].status,
                });
            })
            .then(() => {
                toggleModal();
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        getBorrowDataTable(currentPage);
    }, []);

    const [activeTab, setActiveTab] = useState("1");

    const toggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            propFuc(tab)
        }

    };

    const setStartDate = (e) => {
        setSearchData((prev) => ({
            ...prev,
            dateBorrow: e,
        }))
    }

    const setEndDate = (e) => {
        setSearchData((prev) => ({
            ...prev,
            dateReturn: e,
        }))
    }

    const { insert, setInsert } = useInsertConText();
    useEffect(() => {
        if (insert.task === "select_user_filter") {
            setSearchData((prev) => ({
                ...prev,
                userNameBorrow: insert.insert_name,
            }))
        }
    }, [insert])

    const showDateAndTime = (dateItem) => {
        return `${dayjs.utc(dateItem).add(543, "year").format("DD/MM/YYYY")}  ${dayjs.utc(dateItem).format("HH:mm")}`
    }

    const checkLateReturn = (status, date_return) => {
        return (<Badge
            pill
            color={
                status === 0
                    ? "primary"
                    : status === 1
                        ? "success"
                        : status === 2
                            ? "secondary"
                            : status === 3
                                ? "danger"
                                : status === "late"
                                && "warning"
            }
        >
            {
                filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4) ?
                    status === 0
                        ? "จองแล้ว"
                        : status === 1
                            ? "จ่ายแล้ว"
                            : status === 2
                                ? "คืนแล้ว"
                                : status === 3
                                    ? "ไม่อนุมัติ"
                                    : status === "late"
                                    && "เกินกำหนด"
                    : status === 0
                        ? "จองแล้ว"
                        : status === 1
                            ? "รับแล้ว"
                            : status === 2
                                ? "คืนแล้ว"
                                : status === 3
                                    ? "ไม่อนุมัติ"
                                    : status === "late"
                                    && "เกินกำหนด"
            }
        </Badge>)
    }
    const [acceptBorrow, setAcceptBorrow] = useState(false);
    const [allTaskOption, setAllTaskOption] = useState("")
    const [dataGroup, setDataGroup] = useState({
        task: "",
        id: null,
        equipment_id: null,
        equipment_name: null,
        users_id_borrow: null,
        users_name_borrow: null,
        date_borrow: null,
        remark_borrow: null,
        users_id_use: null,
        users_name_use: null,
        users_id_returner: null,
        users_name_returner: null,
        date_return: null,
        user_id_allot: null,
        user_name_allot: null,
        user_id_repatriate: null,
        user_name_repatriate: null,
    })
    const [checkboxState, setCheckboxState] = useState()
    const [allCheckboxState, setAllCheckboxState] = useState()
    const [checkAllSubmitEquipment, setCheckAllSubmitEquipment] = useState(false)
    const handleToggleModalAcceptBorrow = () => {
        setAcceptBorrow(!acceptBorrow);
    };
    const borrowAcceptAndUnAccept = async (task, id, equipment_id, users_id_borrow, users_name_borrow, date_borrow, remark_borrow, users_id_returner, users_name_returner, date_return, user_id_allot, user_name_allot, user_id_repatriate, user_name_repatriate) => {
        setLoading(false)
        let data
        const url = `/api/borrow/equipment/${id}`
        if (task === "accept") {
            data = {
                equipment_id: equipment_id,
                users_id_borrow: users_id_borrow,
                users_name_borrow: users_name_borrow,
                date_borrow: date_borrow,
                remark_borrow: remark_borrow,
                date_return: date_return,
                status: 1,
                user_id_allot: user_id_allot,
                user_name_allot: user_name_allot,
            }
            await FetchAxiosPut(url, data, token)
        } else if (task === "unaccept") {
            data = {
                equipment_id: equipment_id,
                users_id_borrow: users_id_borrow,
                users_name_borrow: users_name_borrow,
                date_borrow: date_borrow,
                remark_borrow: remark_borrow,
                date_return: date_return,
                status: 3
            }
            await FetchAxiosPut(url, data, token)
        } else if (task === "return") {
            data = {
                equipment_id: equipment_id,
                users_id_borrow: users_id_borrow,
                users_name_borrow: users_name_borrow,
                date_borrow: date_borrow,
                remark_borrow: remark_borrow,
                users_id_returner: Number(users_id_returner),
                users_name_returner: users_name_returner,
                date_return: date_return,
                status: 2,
                user_id_repatriate: user_id_repatriate,
                user_name_repatriate: user_name_repatriate
            }
            await FetchAxiosPut(url, data, token)
        }
        getBorrowDataTable()
        handleToggleModalAcceptBorrow()
        setTimeout(() => {
            setLoading(true)
        }, 1500);
    }
    const [allEquipment, setAllEquipment] = useState([])
    const letEquipmentName = async (id) => {
        let params = new URLSearchParams({
            page: currentPage,
            size: 10,
            "order[0]": "item_id",
            "order[1]": "ASC",
        });
        id.forEach((element, idx) => {
            params.append(`filter[item_id][${idx}]`, element)
        });
        const fetchEquipment = await FetchAxiosGet("/api/equipment/datatable", token, params)
        setAllEquipment(fetchEquipment.result)
    }

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCheckboxChange = (index, item, choice = null) => {
        const keys = Object.keys(item);
        setCheckboxState((prevState) => ({
            ...prevState,
            [index]: choice ?? !prevState[index]?.condition
                ? {
                    condition: !prevState[index]?.condition,
                    ...keys.reduce((acc, key) => {
                        acc[key] = item[key];
                        return acc;
                    }, {}),
                }
                : { condition: choice ?? !prevState[index]?.condition }
        }));
    };

    const selectInput = (item, index) => {
        return (
            <Input addon type="checkbox"
            // disabled={item.status == 1}
            checked={(checkboxState[index]?.condition
                // && item.status !== 1
            ) || false} onClick={() => handleCheckboxChange(index, item)} />
        )
    }

    const loopSelect = (choice) => {
        const newCheckboxState = {};
        borrowData.forEach((item, idx) => {
            const keys = Object.keys(item);
            newCheckboxState[idx] = choice
                ? {
                    condition: true,
                    ...keys.reduce((acc, key) => {
                        acc[key] = item[key];
                        return acc;
                    }, {}),
                }
                : { condition: false };
        });
        setCheckboxState(newCheckboxState);
    }

    const allselectInput = () => {
        return (
            <Input addon type="checkbox" checked={allCheckboxState} onClick={(e) => { loopSelect(!e.target.checked); setAllCheckboxState(!e.target.checked) }} />
        )
    }

    useEffect(() => {
        if (checkboxState) {
            Object?.keys(checkboxState).forEach((item, idx) => {
                setAllCheckboxState(Object.values(checkboxState).every((item) => item?.condition))
            })
        }
    }, [checkboxState])

    const handleFetchGroup = async (task) => {
        if (checkboxState) {
            setLoading(false)
            const group_equipment = task === "return" ? Object.values(checkboxState).filter((item) => item?.condition && item.status === 1) : Object.values(checkboxState).filter((item) => item?.condition && item.status !== 1)

            let group_equipment_transformed
            if (task === "accept") { //ทำเผื่อ ในกรณีที่ต้องการมากกว่า อนุมัติการยืม
                group_equipment_transformed = group_equipment.map((item) => ({
                    id: item.id,
                    source: {
                        equipment_id: item.equipment_id,
                        users_id_borrow: item.users_id_borrow,
                        users_name_borrow: item.users_name_borrow,
                        date_borrow: item.date_borrow,
                        remark_borrow: item.remark_borrow,
                        date_return: item.date_return,
                        status: 1,
                        user_id_allot: user_id,
                        user_name_allot: user_name,
                    },
                }))
            }
            if (task === "return") {
                group_equipment_transformed = group_equipment.map((item) => ({
                    id: item.id,
                    source: {
                        equipment_id: item.equipment_id,
                        users_id_borrow: item.users_id_borrow,
                        users_name_borrow: item.users_name_borrow,
                        date_borrow: item.date_borrow,
                        remark_borrow: item.remark_borrow,
                        date_return: item.date_return,
                        status: 2,
                        user_id_allot: user_id,
                        user_name_allot: user_name,
                        user_id_repatriate: user_id,
                        user_name_repatriate: user_name,
                        users_id_returner: item.users_id_borrow,
                        users_name_returner: item.users_name_borrow,
                    },
                }))
            }
            if (group_equipment.length > 0) {
                const url = `/api/borrow/equipment/group`

                let data = JSON.stringify({ "equipment_group": group_equipment_transformed });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: baseURL + url,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    data: data
                };

                axios.request(config)
                    .then((response) => {
                        setCheckAllSubmitEquipment(false)
                        getBorrowDataTable()
                        handleToggleModalAcceptBorrow()
                        setTimeout(() => {
                            setLoading(true)
                        }, 1500);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
    }

    const selectedItems = Object.values(checkboxState || {}).filter(i => i?.condition);

    const hasSelection = selectedItems.length > 0;
    const hasStatus1 = selectedItems.some(i => i?.status === 1);
    const allStatus1 = hasSelection && selectedItems.every(i => i?.status === 1);

    return (
        <React.Fragment>
            <FadeIn>
                <Card style={{ minHeight: "810px" }}>
                    <CardBody>
                        <Row>
                            <Col>
                                <>
                                    <div className="rounded-2">
                                        <>
                                            <Nav tabs>
                                                <>
                                                    <NavItem>
                                                        <NavLink
                                                            style={{ cursor: "pointer" }}
                                                            className={classnames({
                                                                active: activeTab === "1",
                                                            })}
                                                            onClick={() => {
                                                                toggle("1");
                                                            }}
                                                        >
                                                            <h5>
                                                                {activeTab === "1" ? <i className="fa-solid fa-file-pen font-size-18 me-2"></i> : ""}
                                                                รายการยืมครุภัณฑ์
                                                            </h5>
                                                        </NavLink>
                                                    </NavItem>
                                                </>
                                                {CheckSubAdmin(user?.positionSubAdmin) && (CheckSubAdmin(user?.positionSubAdmin)?.includes(0) || CheckSubAdmin(user?.positionSubAdmin)?.includes(4)) &&
                                                    <>
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames({
                                                                    active: activeTab === "2",
                                                                })}
                                                                onClick={() => {
                                                                    toggle("2");
                                                                }}
                                                            >
                                                                <h5>
                                                                    {activeTab === "2" ? <i className="fa-solid fa-books font-size-18 me-2"></i> : ""}
                                                                    รายการข้อมูลครุภัณฑ์
                                                                </h5>
                                                            </NavLink>
                                                        </NavItem>
                                                    </>
                                                }
                                                <>
                                                    {/* <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "3",
                              })}
                              onClick={() => {
                                toggle("3");
                              }}
                            >
                              <h5>
                                {activeTab === "3" ? <i className="fa-sharp fa-solid fa-book-open-cover font-size-18 me-2"></i> : ""}
                                รายงานการยืมครุภัณฑ์
                              </h5>
                            </NavLink>
                          </NavItem> */}
                                                </>
                                            </Nav>
                                        </>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane TabPane tabId="1">
                                                <Form
                                                    className="pt-3 px-3"
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        getSearchData();
                                                    }}
                                                >
                                                    <FormGroup row>
                                                        <Row>
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2">เลขครุภัณฑ์</Label>
                                                                <Input
                                                                    type="text"
                                                                    placeholder="เลขครุภัณฑ์"
                                                                    value={searchData?.opdcId}
                                                                    onChange={(e) => {
                                                                        setSearchData({
                                                                            ...searchData,
                                                                            opdcId: e.target.value,
                                                                        });
                                                                    }}
                                                                />
                                                            </Col>
                                                            {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4))
                                                                &&
                                                                <Col xxl={3} md={6}>
                                                                    <div>
                                                                        <Label className="text-end ps-0 mt-2">เจ้าหน้าที่</Label>
                                                                        <Col className="mb-2">
                                                                            <InputGroup className="w-100">
                                                                                <Input
                                                                                    readOnly
                                                                                    placeholder="...เลือกเจ้าหน้าที่"
                                                                                    type="text"
                                                                                    value={searchData.userNameBorrow}
                                                                                />
                                                                                <ModalUser task="select_user_filter" />
                                                                            </InputGroup>
                                                                        </Col>
                                                                    </div>
                                                                </Col>
                                                            }
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2">
                                                                    วันที่ยืม
                                                                </Label>
                                                                <MyThaiDatePick
                                                                    key={`dateBorrow-${keyDate}`}
                                                                    showClearButton={true}
                                                                    setDateObj={setStartDate}
                                                                    placeholderText="วัน/เดือน/ปี"
                                                                />
                                                            </Col>
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2">
                                                                    วันที่คืน
                                                                </Label>
                                                                <MyThaiDatePick
                                                                    key={`dateReturn-${keyDate}`}
                                                                    minDate={searchData.dateBorrow}
                                                                    showClearButton={true}
                                                                    setDateObj={setEndDate}
                                                                    placeholderText="วัน/เดือน/ปี" />
                                                            </Col>
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2">
                                                                    ประเภทครุภัณฑ์
                                                                </Label>
                                                                <Col className="px-0">
                                                                    <Input
                                                                        type="select"
                                                                        value={searchData.typeName}
                                                                        onChange={(e) => {
                                                                            setSearchData((prev) => ({
                                                                                ...prev,
                                                                                typeName: e.target.value,
                                                                            }));
                                                                        }}
                                                                    >
                                                                        {allTypeOptions.map((type, index) => (
                                                                            <option key={index} value={index === 0 ? null : type.type_name}>
                                                                                {type.type_name}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                </Col>
                                                            </Col>
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2">สถานะ</Label>
                                                                <Col className="px-0">
                                                                    <Input type="select"
                                                                        defaultValue=""
                                                                        value={searchData.status}
                                                                        onChange={(e) => {
                                                                            setSearchData((prev) => ({
                                                                                ...prev,
                                                                                status: e.target.value,
                                                                            }));
                                                                        }}
                                                                    >
                                                                        <option value="">ทั้งหมด</option>
                                                                        <option value="0">จองแล้ว</option>
                                                                        <option value="1">{filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4) ? "จ่ายแล้ว" : "รับแล้ว"}</option>
                                                                        <option value="2">คืนแล้ว</option>
                                                                        <option value="3">ไม่อนุมัติ</option>
                                                                        {/* <option value="">ยกเลิก</option> */}
                                                                    </Input>
                                                                </Col>
                                                            </Col>
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2 text-white">x</Label>
                                                                <br />
                                                                <Button className="w-100"
                                                                    onClick={() => {
                                                                        setKeyDate((p) => p + 1)
                                                                        setSearchData({
                                                                            opdcId: '',
                                                                            userNameBorrow: '',
                                                                            searchData: '',
                                                                            typeName: '',
                                                                        })
                                                                    }}
                                                                >
                                                                    <i class="fa-regular fa-magnifying-glass-minus me-2"></i>ล้าง
                                                                </Button>
                                                            </Col>
                                                            {!(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) && <Col xxl={3} md={6}></Col>}
                                                            <Col xxl={3} md={6}>
                                                                <Label className="text-end ps-0 mt-2 text-white">x</Label>
                                                                <br />
                                                                <Button type="submit" color="success" className="w-100">
                                                                    <i className="me-2 fas fa-search"></i>ค้นหา
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        <Row className="justify-content-end mt-2">
                                                            <Col xxl={3} md={6}>
                                                                <Button color="info"
                                                                    className="w-100"
                                                                    onClick={() => {
                                                                        setModalState((prev) => "add");
                                                                        toggleModal();
                                                                    }}
                                                                >
                                                                    <i className="fas fa-plus me-2"></i>เพิ่มการยืม
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </FormGroup>
                                                </Form>
                                                <div style={{ overflowX: "scroll", minHeight: "500px" }}>
                                                    <Table striped style={{ verticalAlign: "middle" }} >
                                                        <thead className="table-dark text-nowrap">
                                                            <tr>
                                                                {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) && (<th className="px-4 text-center">{checkboxState && allselectInput()}</th>)}
                                                                <th className="px-4 text-center" style={{ verticalAlign: "middle" }}>ลำดับ</th>
                                                                <th className="px-2" style={{ verticalAlign: "middle" }}>เลขครุภัณฑ์</th>
                                                                {fromIndex ? null : <th style={{ verticalAlign: "middle" }}>ประเภทครุภัณฑ์</th>}
                                                                <th className="px-2" style={{ verticalAlign: "middle" }}>ข้อมูลรายละเอียด</th>
                                                                {fromIndex ? null : <th style={{ verticalAlign: "middle" }}>วันที่ เวลา ทำรายการ</th>}
                                                                <th className="px-2" style={{ verticalAlign: "middle" }}>ข้อมูลการยืม</th>
                                                                <th className="text-center" style={{ verticalAlign: "middle" }}>
                                                                    {borrowData && <ExcelExportComponent dataInput={borrowData} equipmentName={allEquipment} />}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        {!loading ?
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={11}>
                                                                        <LoadingData />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            :
                                                            borrowData?.length === 0 ? (
                                                                <tbody>
                                                                    <tr>
                                                                        <td colSpan="11" className="text-center fs-5">
                                                                            ไม่มีข้อมูล
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            ) : (
                                                                <tbody>
                                                                    {borrowData?.map((item, idx) => {
                                                                        let cp = (currentPage - 1) * 10;
                                                                        return (
                                                                            <tr key={idx}>
                                                                                {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) && (<td className="text-center">{selectInput(item, idx)}</td>)}
                                                                                <td className="text-center px-2 asset-code" style={{ width: '10px' }}>{idx + cp + 1}</td>
                                                                                <td className="text-center px-2 text-nowrap asset-code" style={{ width: '218px' }}>{item?.item_format}</td>
                                                                                {fromIndex ? null : <td>{item.type}</td>}
                                                                                <td className="px-2 text-nowrap">
                                                                                    <ul className="asset-list">
                                                                                        <li>{allEquipment.find(y => Number(y.item_id) === Number(item.equipment_id))?.type_name}</li>
                                                                                        <li>{allEquipment.find(y => Number(y?.item_id) === Number(item?.equipment_id))?.mdata_name}</li>
                                                                                        <li>{allEquipment.find(y => Number(y?.item_id) === Number(item?.equipment_id))?.detail}</li>
                                                                                    </ul>
                                                                                </td>
                                                                                {fromIndex ? null : (
                                                                                    <td className="px-2 text-nowrap" style={{ width: '10px' }}>
                                                                                        {showDateAndTime(item.created_date)}
                                                                                    </td>
                                                                                )}
                                                                                <td className="px-2 text-nowrap">
                                                                                    <div className="borrow-box">
                                                                                        <div className="borrow-row">
                                                                                            <div className="k">ช่วงเวลา</div>
                                                                                            <div className="v text-nowrap">
                                                                                                ตั้งแต่ {showDateAndTime(item.date_borrow)} ถึง {showDateAndTime(item.date_return)}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="borrow-row">
                                                                                            <div className="k">เพื่อใช้งาน</div>
                                                                                            <div className="v text-nowrap">{item.remark_borrow ?? ""}</div>
                                                                                        </div>
                                                                                        <div className="borrow-row">
                                                                                            <div className="k">สถานะ</div>
                                                                                            <div className="v text-nowrap">{checkLateReturn(new Date() > new Date(item.date_return) && item.status === 1 ? "late" : item.status, item.date_return)}</div>
                                                                                        </div>
                                                                                        <div className="borrow-row">
                                                                                            <div className="k">ผู้ใช้ครุภัณฑ์</div>
                                                                                            <div className="v text-nowrap">{item.users_name_borrow}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="px-2 text-nowrap text-center" style={{ width: '25px' }}>
                                                                                    <UncontrolledDropdown style={{ width: '25px', paddingLeft: '10px' }}>
                                                                                        <DropdownToggle className="font-size-16 text-center" tag="a" color="white">
                                                                                            <i className="text-dark mdi mdi-dots-horizontal"></i>
                                                                                        </DropdownToggle>
                                                                                        <DropdownMenu className="dropdown-menu-end">
                                                                                            <DropdownItem
                                                                                                onClick={() => {
                                                                                                    setModalState("view");
                                                                                                    getBorrowById(item.id);
                                                                                                }}
                                                                                            >
                                                                                                รายละเอียด
                                                                                            </DropdownItem>
                                                                                            {
                                                                                                (filterSubAdmin.length > 0) &&
                                                                                                (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4) &&
                                                                                                (item.status === 0 && item.status !== 2) &&
                                                                                                <Fragment>
                                                                                                    <DropdownItem onClick={() => {
                                                                                                        handleToggleModalAcceptBorrow();
                                                                                                        setAllTaskOption("ยืนยันการยืม")
                                                                                                        setDataGroup({
                                                                                                            task: "accept",
                                                                                                            id: item.id,
                                                                                                            equipment_id: item.equipment_id,
                                                                                                            equipment_name: allEquipment.find(y => y.item_id === Number(item.equipment_id))?.detail,
                                                                                                            users_id_borrow: item.users_id_borrow,
                                                                                                            users_name_borrow: item.users_name_borrow,
                                                                                                            date_borrow: item.date_borrow,
                                                                                                            remark_borrow: item.remark_borrow,
                                                                                                            users_id_use: item.users_id_use,
                                                                                                            users_name_use: item.users_name_use,
                                                                                                            users_id_returner: undefined,
                                                                                                            users_name_returner: undefined,
                                                                                                            date_return: item.date_return,
                                                                                                            user_id_allot: user_id,
                                                                                                            user_name_allot: user_name,
                                                                                                            user_id_repatriate: item.users_id_borrow,
                                                                                                            user_name_repatriate: item.users_name_borrow,
                                                                                                        })
                                                                                                    }}>
                                                                                                        อนุมัติการยืม
                                                                                                    </DropdownItem>
                                                                                                    <DropdownItem
                                                                                                        onClick={() => {
                                                                                                            handleToggleModalAcceptBorrow();
                                                                                                            setAllTaskOption("ไม่ยืนยันการยืม")
                                                                                                            setDataGroup({
                                                                                                                task: "unaccept",
                                                                                                                id: item.id,
                                                                                                                equipment_id: item.equipment_id,
                                                                                                                users_id_borrow: item.users_id_borrow,
                                                                                                                users_name_borrow: item.users_name_borrow,
                                                                                                                date_borrow: item.date_borrow,
                                                                                                                remark_borrow: item.remark_borrow,
                                                                                                                users_id_use: item.users_id_use,
                                                                                                                users_name_use: item.users_name_use,
                                                                                                                users_id_returner: undefined,
                                                                                                                users_name_returner: undefined,
                                                                                                                date_return: item.date_return,
                                                                                                                user_id_allot: undefined,
                                                                                                                user_name_allot: undefined,
                                                                                                                user_id_repatriate: item.users_id_borrow,
                                                                                                                user_name_repatriate: item.users_name_borrow,
                                                                                                            })
                                                                                                        }}>
                                                                                                        ไม่อนุมัติ
                                                                                                    </DropdownItem>
                                                                                                </Fragment>
                                                                                            }
                                                                                            {
                                                                                                filterSubAdmin.length > 0 &&
                                                                                                (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4) &&
                                                                                                (item.status === 1 && item.status !== 2) &&
                                                                                                <Fragment>
                                                                                                    <DropdownItem onClick={() => {
                                                                                                        handleToggleModalAcceptBorrow();
                                                                                                        setAllTaskOption("ต้องการคืนครุภัณฑ์")
                                                                                                        setDataGroup({
                                                                                                            task: "return",
                                                                                                            id: item.id,
                                                                                                            equipment_id: item.equipment_id,
                                                                                                            users_id_borrow: item.users_id_borrow,
                                                                                                            users_name_borrow: item.users_name_borrow,
                                                                                                            date_borrow: item.date_borrow,
                                                                                                            remark_borrow: item.remark_borrow,
                                                                                                            users_id_use: item.users_id_use,
                                                                                                            users_name_use: item.users_name_use,
                                                                                                            users_id_returner: item.users_id_borrow,
                                                                                                            users_name_returner: item.users_name_borrow,
                                                                                                            date_return: item.date_return,
                                                                                                            user_id_allot: undefined,
                                                                                                            user_name_allot: undefined,
                                                                                                            user_id_repatriate: user_id,
                                                                                                            user_name_repatriate: user_name,
                                                                                                        })
                                                                                                    }}>
                                                                                                        คืนครุภัณฑ์
                                                                                                    </DropdownItem>
                                                                                                </Fragment>
                                                                                            }
                                                                                            {
                                                                                                (item.status !== 1 && item.status !== 3 && item.status !== 2) &&
                                                                                                <DropdownItem
                                                                                                    onClick={() => {
                                                                                                        setModalState("edit");
                                                                                                        getBorrowById(item.id);
                                                                                                    }}
                                                                                                >
                                                                                                    แก้ไข
                                                                                                </DropdownItem>
                                                                                            }
                                                                                            {
                                                                                                (item.status !== 1 && item.status !== 3 && item.status !== 2) &&
                                                                                                <DropdownItem
                                                                                                    onClick={() => {
                                                                                                        handleToggleModalDeleteBorrow();
                                                                                                        setSelectID(item.id);
                                                                                                    }}
                                                                                                >
                                                                                                    ลบ
                                                                                                </DropdownItem>
                                                                                            }
                                                                                        </DropdownMenu>
                                                                                    </UncontrolledDropdown>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            )
                                                        }
                                                    </Table>
                                                </div>
                                                <br />
                                                <Row>
                                                    <Col md={6}>
                                                        <Row>
                                                            <Col md={6}>
                                                                {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) && (<Button
                                                                    className="mb-3 me-2"
                                                                    disabled={!hasSelection || hasStatus1}
                                                                    onClick={() => {
                                                                        setCheckAllSubmitEquipment("accept")
                                                                        setAllTaskOption("ยืนยันการจ่ายทั้งหมดที่เลือก")
                                                                        handleToggleModalAcceptBorrow();
                                                                    }}
                                                                    color="success"
                                                                >
                                                                    อนุมัติการยืมทั้งหมด
                                                                </Button>)}
                                                                {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4)) && (<Button
                                                                    className="mb-3"
                                                                    disabled={!hasSelection || !allStatus1}
                                                                    onClick={() => {
                                                                        setCheckAllSubmitEquipment("return")
                                                                        setAllTaskOption("ยืนยันการคืนทั้งหมดที่เลือก")
                                                                        handleToggleModalAcceptBorrow();
                                                                    }}
                                                                    color="info"
                                                                >
                                                                    คืนครุภัณฑ์ทั้งหมด
                                                                </Button>)}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col className="d-flex justify-content-end">
                                                        <Pagination aria-label="Page navigation example">
                                                            <PaginationItem disabled={currentPage === 1}>
                                                                <PaginationLink
                                                                    onClick={() => filterHasData ? getSearchData(1) : getBorrowDataTable(1, user.user_id)}
                                                                >
                                                                    หน้าแรก
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                            <PaginationItem disabled={currentPage === 1}>
                                                                <PaginationLink
                                                                    onClick={() => filterHasData ? getSearchData(currentPage - 1) : getBorrowDataTable(currentPage - 1)}
                                                                >
                                                                    ย้อนกลับ
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                            <PaginationItem active>
                                                                <PaginationLink>
                                                                    หน้า {currentPage} จาก {totalPage}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                            <PaginationItem disabled={currentPage === totalPage}>
                                                                <PaginationLink
                                                                    onClick={() => filterHasData ? getSearchData(currentPage + 1) : getBorrowDataTable(currentPage + 1)}
                                                                >
                                                                    ถัดไป
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                            <PaginationItem disabled={currentPage === totalPage}>
                                                                <PaginationLink
                                                                    onClick={() =>
                                                                        filterHasData ? getSearchData(totalPage) :
                                                                            getBorrowDataTable(totalPage, user.user_id)
                                                                    }
                                                                >
                                                                    หน้าสุดท้าย
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        </Pagination>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <Menu2 userID={user_id} />
                                            </TabPane>
                                            <TabPane tabId="3">
                                                <Menu3 userID={user_id} />
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                    <br />
                                </>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <ModalBorrowTable
                    setDataEdit={setDataEdit}
                    getBorrowDataTable={getBorrowDataTable}
                    dataEdit={dataEdit}
                    modalState={modalState}
                    setModalState={setModalState}
                    user={user}
                    openBorrow={openBorrow}
                    toggleModal={toggleModal}
                />
                <ModalDeleteBorrowTable
                    id={selectID}
                    deleteBorrow={deleteBorrow}
                    handleToggleModalDeleteBorrow={handleToggleModalDeleteBorrow}
                    deleteRowBorrow={deleteRowBorrow}
                    getBorrowDataTable={getBorrowDataTable}
                />
                <ModalAcceptBorrowTable
                    allTaskOption={allTaskOption}
                    dataGroup={dataGroup}
                    acceptBorrow={acceptBorrow}
                    handleToggleModaAcceptBorrow={handleToggleModalAcceptBorrow}
                    acceptRowBorrow={checkAllSubmitEquipment ? handleFetchGroup : borrowAcceptAndUnAccept}
                    checkAllSubmitEquipment={checkAllSubmitEquipment}
                    getBorrowDataTable={getBorrowDataTable}
                />
            </FadeIn>
        </React.Fragment>
    );
};

export default BorrowedTable;
